<form class="ui form" [formGroup]="userForm" (ngSubmit)="onSubmit()">
  <!--GENDER-->
  <div class="field">
    <label for="gender" i18n="@@profile-form-gender">Geschlecht:</label>
    <sui-select id="gender"
                class="selection"
                formControlName="gender"
                labelField="name"
                valueField="gender"
                [options]="GENDERS"
                #selectGender>
      @for (option of selectGender.filteredOptions; track option) {
        <sui-select-option [value]="option"></sui-select-option>
      }
    </sui-select>
  </div>
  <!--TITLE-->
  <div class="field">
    <label for="title" i18n="@@profile-form-title">Titel:</label>
    <input id="title" formControlName="title" type="text" name="titel" placeholder="Titel"
           i18n-placeholder="@@title">
  </div>
  @if (!simple) {
    <!--FIRSTNAME-->
    <div class="field required" [class.error]="userForm.controls.firstname.invalid">
      <label for="firstname" i18n="@@profile-form-first-name">Vorname:</label>
      <input id="firstname" formControlName="firstname" type="text" name="firstname" placeholder="Vorname"
             i18n-placeholder="@@profile-form-first-name-placeholder">
    </div>
    <!--LASTNAME-->
    <div class="field required" [class.error]="userForm.controls.lastname.invalid">
      <label for="lastname" i18n="@@profile-form-last-name">Nachname:</label>
      <input id="lastname" formControlName="lastname" type="text" name="lastname" placeholder="Nachname"
             i18n-placeholder="@@profile-form-last-name-placeholder">
    </div>
  }
  <!--STATUS GROUP-->
  <div class="field required" [class.error]="userForm.controls.statusGroup.invalid">
    <label for="statusgroup" i18n="@@profile-form-status-group">Statusgruppe:</label>
    <sui-select id="statusgroup"
                class="selection"
                labelField="name"
                valueField="group"
                [options]="STATUS_GROUPS"
                formControlName="statusGroup"
                #statusGroupSelect>
      @for (option of statusGroupSelect.filteredOptions; track option) {
        <sui-select-option [value]="option"></sui-select-option>
      }
    </sui-select>
  </div>
  <!--TELEPHONE-->
  <div class="field" [class.error]="userForm.controls.telephone.invalid">
    <label for="telephone" i18n="@@profile-form-phone-number">Telefonnummer:</label>
    <input id="telephone" formControlName="telephone" type="tel" name="telephone" placeholder="Telefonnummer"
           i18n-placeholder="@@profile-form-phone-number-placeholder">
  </div>
  <!--INSTITUTION-->
  <div class="field required" [class.error]="userForm.controls.institution.invalid">
    <label for="institution" i18n="@@profile-form-institution">Institution:</label>
    @if (admin || !editUser.institution || domainInstitutions && domainInstitutions.length > 1) {
      <sui-select
        #institutionSelect
        class="selection"
        id="institution"
        formControlName="institution"
        [options]="domainInstitutions ?? institutions"
        [isSearchable]="true"
        labelField="name"
        valueField="_id"
        (selectedOptionChange)="institutionSelectChange($event)"
      >
        @for (option of institutionSelect.filteredOptions; track option._id) {
          <sui-select-option [value]="option"></sui-select-option>
        }
      </sui-select>
      @if (domainInstitutions && domainInstitutions.length > 1) {
        <div class="ui pointing orange basic label" i18n="@@profile-form-mail-info">
          Für Ihre E-Mail-Domain wird zwischen
          @for (inst of domainInstitutions; track inst._id) {
            "{{ inst.name }}"
            @if (!$last) {und}
          }
          unterschieden.
          Kontrollieren Sie daher bitte, ob Sie die zutreffende Institution gewählt haben!
        </div>
      } @else if (!domainInstitutions?.length) {
        <div class="ui red pointing basic label" i18n="@@profile-form-no-institution-info">
          Zur Ihrer E-Mail-Domain gibt es keine Institutionen. Bitte wenden Sie sich an
          <a href="mailto:fit@uni-kassel.de">fit&#64;uni-kassel.de</a>.
        </div>
      }
    } @else {
      {{ editUser.institution.name }}
      <i class="circle info icon" suiPopup [popupTemplate]="popupTemplate"></i>
      <ng-template #popupTemplate>
        <span i18n="@@profile-form-change-institution-info">Wenden Sie sich zur Änderung Ihrer Institution bitte an <a href="mailto:fit@uni-kassel.de">fit&#64;uni-kassel.de</a>!</span>
      </ng-template>
    }
  </div>
  <!--DEPARTMENT-->
  @if (userForm.controls.institution.value) {
    <div class="field">
      <label i18n="@@profile-form-department" for="department">Fachbereich/Abteilung:</label>
      <sui-select
        #departmentSelect
        class="selection"
        id="department"
        formControlName="department"
        [options]="editUser.institution?.departments || []"
        [isSearchable]="true"
      >
        @for (option of departmentSelect.filteredOptions; track option) {
          <sui-select-option [value]="option"></sui-select-option>
        }
      </sui-select>
    </div>
  }
</form>

